export default {
  id: null,
  nome: null,
  tipoAcessoEvento: [],
  inative: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/eventtypemodel.js